export default __webpack_public_path__ + "static/media/banner-free-new.c5e84974.png";